export const AuthPath = {
  Authorize: '/auth/authorize',
} as const
